/**
* @file 资源管理-车辆资源-创建/修改车辆信息
*/
<template>
    <div class="dz-create">
        <h3>{{ title }}</h3>
        <el-form :model="form" :rules="rules" ref="form" label-width="130px" label-position="right"
            :validate-on-rule-change="false">
            <div class="formTitle">
                <span>车辆信息</span>
            </div>
            <div class="table-container">
                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="机构名称" prop="organizationId">
                            <el-select v-model="form.organizationId" filterable :disabled="!!id"
                                v-if="mixinUserInfo?.organizationType === 1">
                                <el-option v-for="(item, i) in organizations" :key="i" :value="item.id"
                                    :label="item.name" />
                            </el-select>
                            <span v-else>{{ organizations && organizations[0] && organizations[0].name }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="车辆编号" prop="vehicleNo">
                            <el-input v-model="form.vehicleNo" placeholder="请输入" maxlength="30" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="车辆号牌" prop="licenseNo">
                            <el-input v-model="form.licenseNo" placeholder="请输入" maxlength="15" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="车辆所属" prop="companyName">
                            <el-input v-model="form.companyName" placeholder="请输入" maxlength="30" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="号牌颜色" prop="licenseColor">
                            <el-select v-model="form.licenseColor" filterable>
                                <el-option v-for="item in $const.LICENSECOLOR" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="车辆责任人" prop="vehicleResponsible">
                            <el-input v-model="form.vehicleResponsible" placeholder="请输入" maxlength="20" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="车辆识别代码" prop="vin">
                            <el-input v-model="form.vin" placeholder="请输入" maxlength="30" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="车辆使用性质" prop="useCharacter">
                            <el-select v-model="form.useCharacter" filterable>
                                <el-option v-for="item in $const.CUSTOMUSENATURE" :label="item.label" :key="item.value"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="核载人数" prop="vehicleSeat">
                            <el-select v-model="form.vehicleSeat" filterable>
                                <el-option v-for="item in $const.SEATNUMBER" :label="item.label" :key="item.value"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="注册日期" prop="registerDate">
                            <el-date-picker v-model="form.registerDate" type="date" placeholder="请选择" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="车身颜色" prop="vehicleColor">
                            <el-select v-model="form.vehicleColor" filterable>
                                <el-option v-for="item in $const.VEHICLECOLOR" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="车辆型号" prop="vehicleModel">
                            <el-input v-model="form.vehicleModel" placeholder="请输入" maxlength="30" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0" class="table-row">
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="行驶证正面" prop="drivingLicenseFront">
                            <up-img :file.sync="form.drivingLicenseFront" width="190" height="80" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="table-cell">
                        <el-form-item label="行驶证背面" prop="drivingLicenseBack">
                            <up-img :file.sync="form.drivingLicenseBack" width="190" height="80" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0" class="table-row">
                    <el-col :span="24" class="table-cell">
                        <el-form-item label="车辆照片" prop="vehiclePhoto">
                            <up-img :file.sync="form.vehiclePhoto" width="190" height="80" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div class="formTitle">
                <span>运输证信息</span>
            </div>
            <div class="table-container">
                <el-row :gutter="0" class="table-row">
                    <el-col :span="24" class="table-cell">
                        <el-form-item label="道路运输证" prop="roadTransportCertificate">
                            <up-img :file.sync="form.roadTransportCertificate" width="190" height="80" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>
        <div style="margin-top: 32px;">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="submitForm" :loading="loading">保存</el-button>
        </div>
    </div>
</template>

<script>
import upImg from '@/components/upImg';

export default {
    name: 'DzVehicleCreate',
    components: { upImg },
    props: {
        id: {
            type: [String, Number],
            default: ''
        },
        title: {
            type: String,
            default: '新增车辆'
        }
    },
    data() {
        return {
            loading: false,
            form: {
                organizationId: '',
                vehicleNo: '',
                licenseNo: '',
                companyName: '',
                licenseColor: '',
                vehicleResponsible: '',
                vin: '',
                useCharacter: '',
                vehicleSeat: '',
                registerDate: '',
                vehicleColor: '',
                vehicleModel: '',
                drivingLicenseFront: '',
                drivingLicenseBack: '',
                vehiclePhoto: '',
                roadTransportCertificate: ''
            }
        };
    },
    computed: {
        /**
         * 表单校验规则
         * @returns {Object}
         */
        rules() {
            const licenseNoValidator = (rule, value, callback) => {
                // 车牌校验
                let xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z][A-Z](([A-Z0-9]{6}$)|([A-Z0-9]{5}$))/;
                let creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z][A-Z][A-Z0-9]{4}[A-Z0-9挂学警港澳]$/;
                if (!value && value !== 0) {
                    callback(new Error('请输入车辆号牌码'));
                } else if (value.length !== 7 && value.length !== 8) {
                    callback(new Error('只能7-8位'));
                } else if (value.length === 7 && !creg.test(value)) {
                    callback(new Error('请输入正确的车辆号牌码'));
                } else if (value.length === 8 && !xreg.test(value)) {
                    callback(new Error('请输入正确的新能源车辆号牌码'));
                } else {
                    callback();
                }
            };
            const vinValidator = (rule, value, callback) => {
                var regu = /^[A-HJ-NPR-Z\d]{17}$/;
                var re = new RegExp(regu);
                if (!value) {
                    callback(new Error('请输入车辆识别代码'));
                } else if (!re.test(value)) {
                    callback(new Error('请输入正确的车辆识别代码'));
                } else {
                    callback();
                }
            };
            return {
                organizationId: [
                    { required: true, message: '请选择机构名称', trigger: 'change' }
                ],
                licenseNo: [
                    { required: true, message: '请输入车辆号牌码', trigger: 'blur' },
                    { validator: licenseNoValidator, trigger: 'blur' }
                ],
                licenseColor: [
                    { required: true, message: '请选择号牌颜色', trigger: 'change' }
                ],
                vin: [
                    { required: true, message: '请输入车辆识别代码', trigger: 'blur' },
                    { validator: vinValidator, trigger: 'blur' }
                ],
                useCharacter: [
                    { required: true, message: '请选择车辆使用性质', trigger: 'change' }
                ],
                vehicleSeat: [
                    { required: true, message: '请选择核载人数', trigger: 'change' }
                ],
                registerDate: [
                    { required: true, message: '请选择注册日期', trigger: 'change' }
                ],
                vehicleColor: [
                    { required: true, message: '请选择车身颜色', trigger: 'change' }
                ],
                vehicleModel: [
                    { required: true, message: '请输入车辆型号', trigger: 'blur' }
                ],
                drivingLicenseFront: [
                    { required: true, message: '请上传行驶证正面', trigger: 'change' }
                ],
                drivingLicenseBack: [
                    { required: true, message: '请上传行驶证背面', trigger: 'change' }
                ],
                vehiclePhoto: [
                    { required: true, message: '请上传车辆照片', trigger: 'change' }
                ],
                roadTransportCertificate: [
                    { required: true, message: '请上传道路运输证照片', trigger: 'change' }
                ]
            };
        }
    },
    async created() {
        await this.mixinOrganizations();
        if (this.mixinUserInfo?.organizationType === 2 && this.organizations?.[0]?.id) {
            this.$set(this.form, 'organizationId', this.organizations[0].id);
        }
        if (this.id) {
            this.getVehicleInfo();
        }
    },
    methods: {
        /**
         * 获取车辆详情
         * @returns {Promise<void>}
         */
        async getVehicleInfo() {
            if (!this.id) return;
            let url = '/api/v1/manage/vehicle/' + this.id;
            let { code, data } = await this.$axios.get(url);
            if (code === 1) {
                // 日期字段转为时间戳
                const dateFields = ['registerDate'];
                dateFields.forEach(field => {
                    if (data[field]) {
                        data[field] = data[field] * 1000;
                    }
                });
                Object.keys(this.form).forEach(key => {
                    this.form[key] = data[key];
                });
            }
        },
        /**
         * 取消表单
         */
        cancel() {
            this.$refs.form.resetFields();
            this.form = {
                organizationId: '',
                vehicleNo: '',
                licenseNo: '',
                companyName: '',
                licenseColor: '',
                vehicleResponsible: '',
                vin: '',
                useCharacter: '',
                vehicleSeat: '',
                registerDate: '',
                vehicleColor: '',
                vehicleModel: '',
                drivingLicenseFront: '',
                drivingLicenseBack: '',
                vehiclePhoto: '',
                roadTransportCertificate: ''
            };
            this.$emit('cancel');
        },
        /**
         * 提交表单
         */
        submitForm() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.saveData();
                }
            });
        },
        /**
         * 保存表单数据
         * @returns {Promise<void>}
         */
        async saveData() {
            this.loading = true;
            const formData = JSON.parse(JSON.stringify(this.form));
            // 日期字段转为10位时间戳
            if (formData.registerDate) {
                formData.registerDate = Math.floor(new Date(formData.registerDate).getTime() / 1000);
            }
            // 去除空值字段
            Object.keys(formData).forEach(key => {
                const value = formData[key];
                if (value === null || value === undefined || value === '') {
                    delete formData[key];
                } else if (Array.isArray(value) && value.length === 0) {
                    delete formData[key];
                } else if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) {
                    delete formData[key];
                }
            });
            if (this.id) {
                formData.id = this.id;
            }
            const url = '/api/v1/manage/vehicle';
            const method = this.id ? 'put' : 'post';
            let { code } = await this.$axios[method](url, formData);
            if (code === 1) {
                this.$message.success('保存成功！');
                this.cancel();
                this.$emit('success');
            }
            this.loading = false;
        }
    }
};
</script>

<style lang="less" scoped>
.dz-create {
    .formTitle {
        font-size: 16px;
        font-weight: bold;
        margin: 20px 0 10px;
    }

    .table-container {
        border: 1px solid #EBEEF5;
        border-bottom: none;
        border-radius: 8px;
        overflow: hidden;
    }

    .table-row {
        margin: 0;

        &:last-child {
            .table-cell {
                border-bottom: 1px solid #EBEEF5;
            }
        }
    }

    .table-cell {
        border-bottom: 1px solid #EBEEF5;
        border-right: 1px solid #EBEEF5;
        padding: 0;
        margin: 0;

        &:last-child {
            border-right: none;
        }
    }

    ::v-deep .el-form {
        margin-top: 0;
    }

    ::v-deep .el-form-item {
        display: flex;
        margin-bottom: 0;

        .el-form-item__label {
            padding: 8px 12px;
            box-sizing: border-box;
            border-right: 1px solid #EBEEF5;
            background: #FBFBFB;
            height: auto;
            margin: 0;
            float: none;
            text-align: left;
            color: #909399;
            font-weight: normal;
        }

        .el-form-item__content {
            flex: 1;
            padding: 8px 12px 0;
            box-sizing: border-box;
            margin-left: 0 !important;
            border: none;
            margin-bottom: 16px;
        }
    }
}
</style>
